export const getVimeoOptions = (videoId, showControls = false) => {
	return {
		id: videoId,
		loop: !showControls,
		byline: false,
		cc: false,
		chromecast: false,
		title: false,
		portrait: false,
		controls: showControls,
		muted: !showControls,
		airplay: false,
		autoplay: false,
		audio_tracks: false,
		background: false,
		vimeo_logo: false,
		transcript: false,
		speed: false,
		quality_selector: false,
		pip: false,
		color: 'ec008c',
	}
}

